/**************
 Cart
 ***************/

// open cart
async function openCart(skipFetch = false) {
    // open cart if not already open
    if (document.querySelector("#miniCart:not([open])")) {
        document.querySelector("#miniCart").showModal();
    }
    document.querySelector("body").classList.add("noScroll");

    // start loading animation
    document.querySelector("#miniCartContent").classList.add("loading");

    // hide empty cart section
    document.querySelector("#miniCartEmpty").classList.remove("active");

    // fetch cart
    if (skipFetch === false) {
        cart = await getCart();
    }

    // stop loading animation
    document.querySelector("#miniCartContent").classList.remove("loading");

    // update cart count in header nav (exclude zero-price and gift items)
    const visibleCount = cart.items.filter(item =>
        parseInt(item.final_price) > 0 && !(item.properties && item.properties["_gift"])
    ).length;
    document.querySelector('#headerIconsCart').textContent = `Cart(${visibleCount})`;

    // check for empty cart and EXIT (exclude zero-price bundle items and gifts)
    const visibleItems = cart.items.filter(item =>
        parseInt(item.final_price) > 0 && !(item.properties && item.properties["_gift"])
    );

    if (visibleItems.length === 0) {
        document.querySelector("#miniCartEmpty").classList.add("active");
        document.querySelector("#miniCartBody").classList.remove("active");
        document.querySelector("#miniCartGift").classList.remove("active");
        document.querySelector("#miniCartIncentive").classList.remove("active");
        document.querySelector("#miniCartFooter").classList.remove("active");
        return;
    }

    // show main cart sections
    document.querySelector("#miniCartBody").classList.add("active");
    document.querySelector("#miniCartFooter").classList.add("active");

    // reset body container
    document.querySelectorAll(".miniCartBodyItem").forEach(element => element.remove());

    // only display one item
    let itemFound = false;
    // if a subscription item, change UI
    let subscriptionCart = false;

    // append cart
    cart.items.forEach(function (item) {
        // if display set up, do nothing
        if (itemFound) return;

        // determine if item has properties and if variety pack
        const hasProperties = item.properties && Object.keys(item.properties).length > 0;
        varietyPack = item.properties["_variety"] || false;

        // if a gift, skip
        if (hasProperties && item.properties["_gift"]) return;

        // if final_price is 0 (e.g. Katching bundle discount applied), skip
        if (parseInt(item.final_price) === 0) return;

        // mark as display item
        itemFound = true;

        // plan information
        const planInfo = planInformation[item.properties["_plan"]];

        // determine if a subscription and change autoship savings
        const subscriptionItem = item.selling_plan_allocation;
        if (subscriptionItem) {
            subscriptionCart = true;
            if (hasProperties && planInfo) {
                let price = parseFloat(planInfo.price);
                let compare = parseFloat(planInfo.compare_price);
                document.querySelector('#miniCartFooterSubscriptionLineSub').textContent = `-$${(price - compare).toFixed(2)}/mo`;
            }
        }

        // upgrade button HTML
        function itemTopHTML() {
            // check if already a subscription
            if (subscriptionItem) {
                return "";
            }

            // try once type
            let type = ""
            if (hasProperties && planInfo) {
                type = planInfo.title;
            }

            // return HTML
            return `
                <label class="miniCartBodyItemMainLabel">
                    <input type="radio" name="subscription" checked 
                    value="otp" class="miniCartBodyItemMainLabelInput">
                    <span class="miniCartBodyItemMainLabelIndicator"></span>
                    <span class="miniCartBodyItemMainLabelTitle">Try Once${type ? `: For ${type}` : ""}</span>
                </label>
            `;
        }

        // savings HTML
        function savingsHTML() {
            // if otp skip savings
            if (!subscriptionItem) {
                return "";
            }

            // check for a plan and savings info
            let savings = "";
            if (hasProperties && planInfo) {
                savings = planInfo.savings;
            } else {
                return "";
            }

            // return info
            if (savings === "") return "";
            return `<div class="miniCartBodyItemSavings">${savings}</div>`;
        }

        // variant HTML
        function variantHTML() {
            // check for default variant
            if (item.variant_title === null) {
                return "";
            }
            // check if variety
            if (hasProperties && varietyPack) {
                return `
                        <div class="miniCartBodyItemVariant">1 Pouch / Berry</div>
                        <div class="miniCartBodyItemVariant">1 Pouch / Unflavored</div>
                `;
            }
            // check if family plan, changes quantity
            if (hasProperties && planInfo?.title === "Families") {
                return `<div class="miniCartBodyItemVariant">2 Pouches / ${item.variant_title}</div>`;
            }

            // else return single pack
            return `<div class="miniCartBodyItemVariant">1 Pouch / ${item.variant_title}</div>`;
        }

        // billed HTML
        function billedHTML() {
            // if otp skip billed text
            if (!subscriptionItem) {
                return "";
            }

            // else return billed info
            return planInfo ? `<div class="miniCartBodyItemBilled">${planInfo.billed}</div>` : "";
        }

        // price HTML
        function priceHTML() {
            // price is determined by quantity/plan group - if none found, return actual price
            if (!hasProperties || !planInfo) {
                const isOneTime = hasProperties && item.properties["_otp"];
                return `<div class="miniCartBodyItemPrice">${price(item.final_line_price)}${isOneTime ? '' : ' '}</div>`;
            }

            switch (planInfo.title) {
                case "Families":
                    return `
                        <span>$${subscriptionCart ? planInfo.compare_price : planInfo.price} monthly</span>
                    `;
                case "Kids":
                    return `
                        <span>$${subscriptionCart ? planInfo.compare_price : planInfo.price} monthly</span>
                        <span class="miniCartBodyItemPriceSmall">(2 month supply)</span>
                    `;
                default:
                    return `
                        <span>$${subscriptionCart ? planInfo.compare_price : planInfo.price} monthly</span>
                        <span class="miniCartBodyItemPriceSmall">(1 month supply)</span>
                    `;
            }
        }

        // insert item
        document.querySelector("#miniCartBody").insertAdjacentHTML("beforeend", `
            <div class="miniCartBodyItem" data-key="${item.key}">
                <div class="miniCartBodyItemStack">
                    ${itemTopHTML()}
                    <div class="miniCartBodyItemMain">
                        <img class="miniCartBodyItemImage" src="${varietyPack ? "https://cdn.shopify.com/s/files/1/0944/7748/4397/files/variety.png?v=1771014318" : item.image}&width=200" alt="${item.product_title}">
                        <div class="miniCartBodyItemStack">
                            ${savingsHTML()}
                            <div class="miniCartBodyItemTitle">${item.product_title}</div>
                            ${variantHTML()}
                            ${billedHTML()}
                        </div>
                    </div>
                </div>
                <div class="miniCartBodyItemStack">
                    <div class="miniCartBodyItemPrice">${priceHTML()}</div>
                    <button class="miniCartBodyItemRemove">
                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g clip-path="url(#clip0_1360_1025)">
                                <path d="M18.5175 4.73999H1.48248C1.06748 4.73999 0.72998 4.40249 0.72998 3.98749C0.72998 3.57249 1.06748 3.23499 1.48248 3.23499H18.5175C18.9325 3.23499 19.27 3.57249 19.27 3.98749C19.27 4.40249 18.9325 4.73999 18.5175 4.73999Z" fill="#454545"/>
                                <path d="M10.3876 19.77H9.61256C6.84256 19.77 5.31756 19.77 4.23256 18.7575C3.15006 17.745 3.04756 16.2225 2.86256 13.4575L2.40256 6.54497C2.37506 6.12997 2.68756 5.77247 3.10256 5.74497C3.51756 5.71747 3.87506 6.02997 3.90256 6.44497L4.36256 13.3575C4.52756 15.8175 4.61006 17.0525 5.26006 17.66C5.91006 18.2675 7.14756 18.2675 9.61256 18.2675H10.3876C12.8526 18.2675 14.0901 18.2675 14.7401 17.66C15.3901 17.0525 15.4726 15.8175 15.6376 13.3575L16.0976 6.44497C16.1251 6.02997 16.4851 5.71747 16.8976 5.74497C17.3126 5.77247 17.6251 6.12997 17.5976 6.54497L17.1376 13.4575C16.9526 16.2225 16.8526 17.745 15.7676 18.7575C14.6851 19.77 13.1576 19.77 10.3876 19.77Z" fill="#454545"/>
                                <path d="M7.99514 14.76C7.61264 14.76 7.28764 14.47 7.24764 14.0825L6.74764 9.07245C6.70514 8.65995 7.00764 8.28996 7.42014 8.24996C7.83264 8.20746 8.20264 8.50995 8.24264 8.92245L8.74264 13.9325C8.78514 14.345 8.48264 14.715 8.07014 14.755C8.04514 14.7575 8.02014 14.76 7.99514 14.76Z" fill="#454545"/>
                                <path d="M12.0049 14.76C11.9799 14.76 11.9549 14.76 11.9299 14.755C11.5174 14.7125 11.2149 14.345 11.2574 13.9325L11.7574 8.92245C11.7999 8.50995 12.1674 8.20746 12.5799 8.24996C12.9924 8.29246 13.2949 8.65995 13.2524 9.07245L12.7524 14.0825C12.7124 14.47 12.3874 14.76 12.0049 14.76Z" fill="#454545"/>
                                <path d="M15.5127 4.74004C15.4477 4.74004 15.4152 4.74004 15.3852 4.74004C14.8277 4.72504 14.2952 4.54754 13.8427 4.22004C13.3902 3.89504 13.0527 3.44504 12.8627 2.92254C12.8527 2.89504 12.8427 2.86254 12.8202 2.80004L12.7227 2.50754C12.6577 2.31504 12.6177 2.19004 12.5902 2.13754C12.4802 1.92754 12.2752 1.78004 12.0427 1.74254C11.9827 1.73254 11.8502 1.73254 11.6502 1.73254H8.35518C8.15268 1.73254 8.02018 1.73254 7.96268 1.74254C7.72768 1.78004 7.52518 1.92754 7.41518 2.13754C7.38768 2.19004 7.34518 2.31754 7.28268 2.50754L7.18518 2.80004C7.16518 2.86254 7.15268 2.89254 7.14268 2.92254C6.95268 3.44504 6.61518 3.89504 6.16268 4.22004C5.71018 4.54504 5.17768 4.72504 4.62018 4.74004C4.59018 4.74004 4.55768 4.74004 4.49268 4.74004V3.23754C4.53768 3.23754 4.56268 3.23754 4.58268 3.23754C5.10268 3.22504 5.55268 2.90004 5.72768 2.41254C5.73518 2.39254 5.74268 2.37004 5.75768 2.32754L5.85518 2.03504C5.94768 1.75754 5.99768 1.60504 6.08018 1.44504C6.40768 0.815044 7.02268 0.372544 7.72518 0.260044C7.90268 0.232544 8.06268 0.232544 8.35518 0.232544H11.6502C11.9427 0.232544 12.1027 0.232544 12.2802 0.260044C12.9827 0.372544 13.5952 0.815044 13.9252 1.44504C14.0077 1.60254 14.0577 1.75504 14.1502 2.03254L14.2477 2.32754C14.2627 2.37254 14.2702 2.39254 14.2777 2.41254C14.4552 2.90004 14.9052 3.22504 15.4227 3.23754C15.4427 3.23754 15.4677 3.23754 15.5127 3.23754V4.74004Z" fill="#454545"/>
                            </g>
                            <defs>
                                <clipPath id="clip0_1360_1025">
                                    <rect width="20" height="20" fill="white"/>
                                </clipPath>
                            </defs>
                        </svg>
                    </button>
                </div>
            </div>
        `);

        // add incentive item
        if (!subscriptionCart && planInfo) {
            document.querySelector('#miniCartIncentive').classList.add('active');
            document.querySelector('#miniCartIncentiveTopSave').textContent = planInfo.savings;
            // replace current input
            document.querySelector("#miniCartIncentiveLabelWrap").innerHTML = `
                <label id="miniCartIncentiveLabel">
                    <input type="radio" name="subscription" 
                    data-plan="${item.properties["_plan"]}"
                    data-quantity="${planInfo.title === "Families" ? 2 : 1}"
                    data-key="${item.key}" 
                    value="subscription" id="miniCartIncentiveLabelInput">
                    <span id="miniCartIncentiveLabelIndicator"></span>
                    <span id="miniCartIncentiveLabelInner">
                        <span class="miniCartIncentiveLabelInnerSection">
                            <span id="miniCartIncentiveLabelSupply">${planInfo.supply}</span>
                            <span id="miniCartIncentiveLabelBilled">${planInfo.billed}</span>
                        </span>
                        <span class="miniCartIncentiveLabelInnerSection">
                            <span id="miniCartIncentiveLabelServings">${planInfo.servings}</span>
                            <span id="miniCartIncentiveLabelPer">${planInfo.per}</span>
                        </span>
                    </span>
                </label>
            `;

            // add listener on inputs to update/override the subtotal
            document.querySelectorAll('input[name="subscription"]').forEach(input => {
                input.addEventListener('change', function () {
                    document.querySelector('#miniCartFooterSubtotalPrice').textContent =
                        this.value === "subscription"
                            ? planInfo.title === 'Kids' ? "$79.99" : `$${planInfo.compare_price}`
                            : planInfo.title === 'Kids' ? "$99.99" : `$${planInfo.price}`;
                })
            })

        } else {
            document.querySelector('#miniCartIncentive').classList.remove('active');
        }
    });

    // event listener for each line item
    document.querySelectorAll(`.miniCartBodyItem`).forEach(function (element) {
        // get key
        let key = element.dataset.key;

        // clear cart with trash can
        element.querySelector(".miniCartBodyItemRemove").addEventListener("click", async function () {

            // start loading animation
            document.querySelector("#miniCartContent").classList.add("loading");

            // update cart in shopify
            await fetch("/cart/clear.js");

            // update active body
            await openCart();
        });
    });

    // display price (only sum visible items)
    const visibleSubtotal = cart.items
        .filter(item => parseInt(item.final_price) > 0 && !(item.properties && item.properties["_gift"]))
        .reduce((sum, item) => sum + item.final_line_price, 0);

    document.querySelector('#miniCartFooterSubtotalPrice').textContent =
        cart.total_price === 11998 ? "$118.99" : price(visibleSubtotal);

    // if subscription, show the savings above subtotal and gifts
    subscriptionCart
        ? document.querySelectorAll('#miniCartGift,#miniCartFooterSubscription').forEach(el => el.classList.add('active'))
        : document.querySelectorAll('#miniCartGift,#miniCartFooterSubscription').forEach(el => el.classList.remove('active'));
}

// close event
document.querySelector("#miniCart").addEventListener("close", function () {
    document.querySelector("body").classList.remove("noScroll");
});

// close cart function
function closeCart() {
    document.querySelector("#miniCart").close();
}

// open cart event listener
document.querySelectorAll(".openCart").forEach(function (element) {
    element.addEventListener("click", function (e) {
        e.preventDefault();
        openCart();
    });
});

// close cart event listener
document.querySelectorAll(".closeCart").forEach(function (element) {
    element.addEventListener("click", closeCart);
});

// close cart on overlay click
document.querySelector("#miniCart").addEventListener("click", function (e) {
    if (e.target === this) {
        closeCart();
    }
})

// if variety, mark for subscription update
let varietyPack = false;

// checkout
document.querySelector("#miniCartFooterCheckout").addEventListener("click", async function () {
    // add loading
    this.classList.add("loading");

    // check for subscription update
    if (document.querySelector('#miniCartIncentiveLabelInput')?.checked) {
        // input and plan id
        const checkInput = document.querySelector('#miniCartIncentiveLabelInput:checked');
        const planId = parseInt(checkInput.dataset.plan);

        // add gifts
        const formData = [
            // canister
            {
                quantity: 1,
                id: 52842351591789,
                properties: {
                    _gift: true
                }
            },
            // frother
            {
                quantity: 1,
                id: 52842350084461,
                properties: {
                    _gift: true
                }
            }
        ];

        // if variety pack
        if (varietyPack) {
            // clear cart
            await fetch('/cart/clear.js');
            // add new items with plan to cart with gifts
            formData.push(
                {
                    id: 52818497929581,
                    quantity: 1,
                    selling_plan: planId,
                    properties: {
                        _plan: planId,
                        _variety: true
                    }
                },
                {
                    id: 52818497896813,
                    quantity: 1,
                    selling_plan: planId,
                    properties: {
                        _plan: planId,
                        _variety: true
                    }
                }
            )
        } else {
            // add plan
            await changeCart({
                id: checkInput.dataset.key,
                quantity: parseInt(checkInput.dataset.quantity),
                selling_plan: planId
            });
        }

        // add product
        await addProduct({items: formData});
    }

    // remove loading
    this.classList.remove("loading");
    // go to checkout
    window.location.href = `${Shopify.routes.root}checkout`;
});

// check is coming from the cart
if (document.referrer.includes("/cart")) {
    openCart().catch(err => console.log(err));
}